import React, { useEffect } from "react";
import Table from 'react-bootstrap/Table';
import Graph from '../../components/Graph';
import {
    FaMotorcycle,
    FaCarSide,
    FaShuttleVan,
    FaTruckPickup,
    FaTruck,
    FaBus,
    FaTruckMoving,
    FaRegQuestionCircle,
    } from 'react-icons/fa';

const VehClass = (props) => {

    const {
        vehicleClass,
        options,
        assetName,
        vehicleClassTbl,
        setVehicleClass,
        setVehicleClassTbl,
        counts,
        chartColors
     } = props


    // VEHICLE CLASSIFICATION START
    // --------------------------
    useEffect(() => {
        // Total vehicles classification
        const getVehicleClass = () => {

            let ped = 0;
            let bike = 0;
            let moto = 0;
            let car = 0;
            let van = 0;
            let short_truck = 0;
            let long_truck = 0;
            let med_truck = 0;
            let bus = 0;
            let undef = 0;

            for (let i = 0; i < counts.length; i++){
                // ped += counts[i].entries.filter(item => {return item.CLASS === 'PEDESTRIAN' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                // bike += counts[i].entries.filter(item => {return item.CLASS === 'BIKE' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                moto += counts[i].entries.filter(item => {return item.CLASS === 'MOTORBIKE' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                car += counts[i].entries.filter(item => {return item.CLASS === 'CAR' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                van += counts[i].entries.filter(item => {return item.CLASS === 'VAN' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                short_truck += counts[i].entries.filter(item => {return item.CLASS === 'SHORT TRUCK' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                med_truck += counts[i].entries.filter(item => {return item.CLASS === 'MED TRUCK' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                long_truck += counts[i].entries.filter(item => {return item.CLASS === 'LONG TRUCK' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                bus += counts[i].entries.filter(item => {return item.CLASS === 'BUS' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
                undef += counts[i].entries.filter(item => {return item.CLASS === 'UNDEFINED' }).reduce((sum, item) => {return sum = sum + parseInt(item.VOLUME) }, 0);
            }

            let data = {}

            if (med_truck===0 && bus===0){
                // Graph data
                data = {
                    labels: ['Motorbike', 'Car', 'Van', 'Short Truck', 'Long Truck', 'Undefined'],
                    datasets: [{
                        label: 'Count',
                        data: [moto, car, van, short_truck, long_truck, undef,],
                        borderColor: [
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            chartColors[3], 
                            chartColors[9]],
                        backgroundColor: [
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            chartColors[3], 
                            chartColors[9]],
                        borderWidth: 1
                    }]
                }
            }else{
                // Graph data
                data = {
                    labels: ['Motorbike', 'Car', 'Van', 'Short Truck', 'Med Truck', 'Long Truck', 'Bus', 'Undefined'],
                    datasets: [{
                        label: 'Count',
                        data: [moto, car, van, short_truck, med_truck, long_truck, bus, undef,],
                        borderColor: [
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            chartColors[6], 
                            chartColors[3], 
                            chartColors[0], 
                            chartColors[9]],
                        backgroundColor: [
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            chartColors[6], 
                            chartColors[3], 
                            chartColors[0], 
                            chartColors[9]],
                        borderWidth: 1
                    }]
                }
            }

            setVehicleClass(data);
            setVehicleClassTbl([ped, bike, moto, car, van, short_truck, med_truck, long_truck, bus, undef]);
        }

        getVehicleClass();

    // eslint-disable-next-line 
    },[counts, setVehicleClass, setVehicleClassTbl]);
    // VEHICLE CLASSIFICATION END

return (
    <div className="col-md-12 p-2">
        <h2 className="text-header">Vehicle Classification</h2>
        <div className="text-description small pb-3">
        total counts by type of vehicle
        </div>
        <div className="row">
            <div className="col-md-12">
            {(vehicleClass.datasets && vehicleClass.datasets.length > 0)?
                <Graph
                title="Vehicle Classification"
                type="bar"
                data={vehicleClass}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-12">
            <Table responsive hover className="small p-0 border">
            <thead>
                <tr>
                <th className="table-th-det"></th>
                <th className="table-th-det">Vehicle type</th>
                <th className="table-th-det">Count</th>
                </tr>
            </thead>
            <tbody>
            <tr className="table-tr">
                <td className="table-th"><FaMotorcycle /></td>
                <td className="table-td-det">Motorbike</td>
                <td className="table-td">{vehicleClassTbl[2]}</td>
            </tr>
            <tr className="table-tr">
                <td className="table-th"><FaCarSide /></td>
                <td className="table-td-det">Car</td>
                <td className="table-td">{vehicleClassTbl[3]}</td>
            </tr>
            <tr className="table-tr">
                <td className="table-th"><FaShuttleVan /></td>
                <td className="table-td-det">Van</td>
                <td className="table-td">{vehicleClassTbl[4]}</td>
            </tr>
            <tr className="table-tr">
                <td className="table-th"><FaTruck /></td>
                <td className="table-td-det">Short Truck</td>
                <td className="table-td">{vehicleClassTbl[5]}</td>
            </tr>
            {/* FaTruckPickup */}
            {(vehicleClassTbl && vehicleClassTbl[6]>0) ?
            <tr className="table-tr">
                <td className="table-th"><FaTruckPickup /></td>
                <td className="table-td-det">Med Truck</td>
                <td className="table-td">{vehicleClassTbl[6]}</td>
            </tr>
            :<></>}       
            {/* FaTruckMoving */}
            <tr className="table-tr">
                <td className="table-th"><FaTruckMoving /></td>
                <td className="table-td-det">Long Truck</td>
                <td className="table-td">{vehicleClassTbl[7]}</td>
            </tr>         
            {(vehicleClassTbl && vehicleClassTbl[8]>0) ?
            <tr className="table-tr">
                <td className="table-th"><FaBus /></td>
                <td className="table-td-det">Bus</td>
                <td className="table-td">{vehicleClassTbl[8]}</td>
            </tr>
            :<></>}
            <tr className="table-tr">
                <td className="table-th"><FaRegQuestionCircle /></td>
                <td className="table-td-det">Undefined</td>
                <td className="table-td">{vehicleClassTbl[9]}</td>
            </tr>
            </tbody>
            </Table>

            </div>
        </div>
    </div>
)}

export default VehClass;